import { motion } from 'framer-motion';

export const PricingHero: React.FC = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-32 sm:pb-12 relative overflow-hidden">
      {/* Multi-layered gradient background */}
      <div className="absolute inset-0 -z-10">
        {/* Base purple layer */}
        <div
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(ellipse 80% 50% at 50% -20%, rgba(var(--primary-rgb), 0.12), transparent)',
          }}
        />
        {/* Orange accent - right side */}
        <div
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(circle at 90% 30%, rgba(var(--grow-rgb), 0.08), transparent 50%)',
          }}
        />
        {/* Teal accent - left side */}
        <div
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(circle at 10% 70%, rgba(var(--secondary-rgb), 0.06), transparent 50%)',
          }}
        />
        {/* Noise texture */}
        <div className="absolute inset-0 bento-noise opacity-[0.02]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        {/* Main headline */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-6"
        >
          Choose Your Path to
          <br />
          <span className="bg-gradient-to-r from-primary via-grow to-secondary bg-clip-text text-transparent">
            Business Success
          </span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed"
        >
          Pick the plan that fits your needs. Start with a 14-day free trial.
          <span className="block mt-1 text-foreground font-medium">
            No credit card required. Cancel anytime.
          </span>
        </motion.p>
      </div>
    </section>
  );
};

export default PricingHero;
